export const priceFormatter = (value: number): string => {
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2
  }).format(value);
};
